
import React from "react";

// Oruclicks logo component (SVG asset)
const CLogo = ({
  size = "45px",
  textSize = "24px",
  showText = true,
  iconOnly = false,
  isDarkTheme = false,
  onClick,
  className,
  style
}) => {
  const resolvedSize = typeof size === "number" ? `${size}px` : size;
  const resolvedTextSize = typeof textSize === "number" ? `${textSize}px` : textSize;

  return (
    <div
      onClick={onClick}
      className={className}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "10px",
        cursor: onClick ? "pointer" : "default",
        ...style
      }}
    >
      <img
        src="/Logo/OruClickLogo.svg"
        alt="OruClick Logo"
        width={resolvedSize}
        height={resolvedSize}
        style={{
          display: "block",
          filter: isDarkTheme ? "brightness(1.15)" : "none"
        }}
      />
      {!iconOnly && showText && (
        <span
          style={{
            display: "flex",
            flexDirection: "column",
            lineHeight: 1.1,
            fontFamily: "Manrope, Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
            textRendering: "optimizeLegibility"
          }}
        >
          <span
            style={{
              fontSize: `calc(${resolvedTextSize} * 0.42)`,
              fontWeight: 600,
              letterSpacing: "0.4px",
              color: isDarkTheme ? "#C5D1FF" : "#8A94A6"
            }}
          >
            OruClick
          </span>
          <span
            style={{
              fontSize: resolvedTextSize,
              fontWeight: 800,
              letterSpacing: "0.2px",
              color: isDarkTheme ? "#FFFFFF" : "#0F172A"
            }}
          >
            Engage
          </span>
        </span>
      )}
    </div>
  );
};

export default CLogo;
